module.exports = __webpack_public_path__ + "static/media/folder-minus.5a0a784c.svg";